import React, { useState } from 'react';

export function ContactPage() {
  const [name, setName] = useState('');
  const [org, setOrg] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Uttar Labs Inquiry — ${org || 'General'}`);
    const body = encodeURIComponent(`Name: ${name}\nOrganization: ${org}\nEmail: ${email}\n\n${message}`);
    window.location.href = `mailto:anzelix@gmail.com?subject=${subject}&body=${body}`;
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '0.65rem 0.875rem',
    border: '1.5px solid #e2e8f0',
    borderRadius: 10,
    fontSize: '0.95rem',
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block',
    fontSize: '0.85rem',
    fontWeight: 600,
    color: '#374151',
    marginBottom: '0.4rem',
  };

  return (
    <div className="tab-content">
      <section className="hero-section">
        <h1 className="hero-title">Contact Us</h1>
        <p className="hero-subtitle">
          Ready to explore what AI can do for your organization? Fill in the form and we'll get back within 24 hours.
        </p>
      </section>

      <section className="section">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2.5rem', maxWidth: 920, margin: '0 auto' }}>

          {/* Contact form */}
          <div className="card" style={{ padding: '2.5rem' }}>
            <h2 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#1e293b', marginBottom: '1.5rem' }}>
              Send us a message
            </h2>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div>
                <label style={labelStyle}>Your Name *</label>
                <input required value={name} onChange={e => setName(e.target.value)} placeholder="Hari Sharma" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Organization</label>
                <input value={org} onChange={e => setOrg(e.target.value)} placeholder="Ministry / Bank / Hospital / ..." style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>Your Email *</label>
                <input required type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@organization.gov.np" style={inputStyle} />
              </div>
              <div>
                <label style={labelStyle}>How can we help? *</label>
                <textarea
                  required
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  rows={5}
                  placeholder="Describe your organization's challenge or what you're looking to build..."
                  style={{ ...inputStyle, resize: 'vertical' }}
                />
              </div>
              <button
                type="submit"
                style={{
                  padding: '0.875rem',
                  background: 'linear-gradient(135deg, #0f4c81 0%, #0891b2 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '10px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  fontSize: '1rem',
                }}
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact info */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
            <div className="card">
              <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>📧</div>
              <h3 style={{ fontWeight: 700, color: '#1e293b', marginBottom: '0.25rem' }}>Email</h3>
              <a href="mailto:anzelix@gmail.com" style={{ color: '#0891b2', fontWeight: 600 }}>anzelix@gmail.com</a>
            </div>

            <div className="card">
              <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>📍</div>
              <h3 style={{ fontWeight: 700, color: '#1e293b', marginBottom: '0.25rem' }}>Location</h3>
              <p style={{ color: '#64748b' }}>Kathmandu, Nepal</p>
            </div>

            <div className="card">
              <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>🕐</div>
              <h3 style={{ fontWeight: 700, color: '#1e293b', marginBottom: '0.25rem' }}>Response Time</h3>
              <p style={{ color: '#64748b' }}>We respond to all inquiries within 24 hours.</p>
            </div>

            <div className="card" style={{ background: 'linear-gradient(135deg, #f0f9ff, #e0f2fe)', border: 'none' }}>
              <h3 style={{ fontWeight: 700, color: '#0f4c81', marginBottom: '0.5rem' }}>Free Consultation</h3>
              <p style={{ color: '#0369a1', fontSize: '0.9rem', lineHeight: 1.65 }}>
                Not sure what you need? We offer a free 30-minute consultation to help you understand how AI can solve your specific organizational challenges — no commitment required.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
